import {
  GET_MANUAL_FACILITIES,
  GET_MANUAL_FACILITIES_SUCCESS,
  GET_MANUAL_FACILITIES_ERROR,
  GET_MANUAL_FACILITIES_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const GetManualFacilities = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUAL_FACILITIES:
      return { ...state, loading: true, data: null, error: null };
    case GET_MANUAL_FACILITIES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_MANUAL_FACILITIES_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_MANUAL_FACILITIES_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default GetManualFacilities;
